export default __webpack_public_path__ + "static/eventForm-9c8d09d9534e782cbf2e617a3d6ed063.gif";